import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import { Image as ImageElem } from './Image.styles';

const mediaQueries = {
  sm: '(max-width: 767px)',
  md: '(min-width: 768px) and (max-width: 1023px)',
  lg: '(min-width: 1024px)',
};

const Image = ({ image }) => (
  <ImageElem>
    <Media queries={mediaQueries} defaultMatches={{ lg: true }}>
      {(matches) => {
        if (matches.sm) {
          return (
            <img
              src={image.sm.url}
              alt={image.title}
              className="w-full h-full rounded-lg object-cover object-center"
            />
          );
        }
        return (
          <img src={image.lg.url} alt={image.title} className="w-full h-full rounded-lg object-cover object-center" />
        );
      }}
    </Media>
  </ImageElem>
);

Image.propTypes = {
  image: PropTypes.shape({
    title: PropTypes.string,
    lg: PropTypes.shape(),
    sm: PropTypes.shape(),
  }).isRequired,
};

export default Image;
